module.exports = __webpack_public_path__ + "static/media/logo1.8ab7c4f1.webp";